export const MAKE_WAC_FAILED_TUTORIAL_INACTIVE = 'MAKE_WAC_FAILED_TUTORIAL_INACTIVE';

/**
 * Turn off the WAC failed tutorial. We do this when the user answers a question
 * that the WAC failed tutorial would have been shown for before they have
 * dismissed it
 * @returns {{type: string}}
 */
export function makeWacFailedTutorialInactive() {
    return { type: MAKE_WAC_FAILED_TUTORIAL_INACTIVE };
}
